import { List } from 'immutable';
import * as React from 'react'
import { Block, BlockRenderer } from '../../block_renderer';
import { CollectionSearchBar } from '../../collection_search_bar';
import { AdviceScrollAnchor } from '../Advice/Advice';

interface InspirationWrapperProps {
  readonly pageTitle: string
  readonly headerTitle: string
  readonly description: string
  readonly imageUrl: string
  readonly imageAlt: string
  readonly buttonUrl: string
  readonly buttonTitle: string
  readonly header_blocks: List<Block>
  readonly blocks: List<Block>
  readonly children?: React.ReactNode
}

interface InspirationWrapperState { }

export class InspirationWrapper extends React.Component<InspirationWrapperProps, InspirationWrapperState> {

  constructor(props: InspirationWrapperProps) {
    super(props)
    this.state = {}
  }


  render() {

    const p = this.props
    const s = this.state

    return <>
      <header className="jumbotron jumbotron--small jumbotron--ip">
        <h1 className="sr-text">{p.pageTitle}</h1>
        <div className="container-fluid">
          <section className="search-wrapper search-wrapper--ip">
            <CollectionSearchBar />
          </section>
        </div>
      </header>
      <BlockRenderer blocks={p.header_blocks} />

      <AdviceScrollAnchor />
      {p.children}
      <BlockRenderer blocks={p.blocks} />
    </>
  }
}